<template>
  <div>
    <CHeader fixed with-subheader light c-header-fixed :color-scheme="this.$store.state.theme_mode">
      <CToggler
          in-header
          class="ml-3 d-lg-none"
          @click="$store.commit('toggleSidebarMobile')"
      />
      <!--          <CToggler-->
      <!--              in-header-->
      <!--              class="ml-3 d-md-down-none"-->
      <!--              @click="$store.commit('toggleSidebarDesktop')"-->
      <!--          />-->
      <CHeaderBrand class="mx-auto d-lg-none" to="/">
        <!--      <CIcon name="logo" height="48" alt="Logo"/>-->
      </CHeaderBrand>

      <CHeaderNav class="d-md-down-none">
        <!--        <CHeaderNavItem class=" border-left">-->
        <!--          <CHeaderNavLink to="/dashboard/orders/add-order">-->
        <!--            {{ $t('sidebars.addOrder') }}-->
        <!--          </CHeaderNavLink>-->

        <!--        </CHeaderNavItem>-->
        <!--        <CDropdown-->

        <!--            class="c-header-nav-items mr-3 border-left"-->
        <!--            :placement="drop_down_placement"-->
        <!--            add-menu-classes=""-->
        <!--        >-->
        <!--          <template #toggler>-->
        <!--            <CHeaderNavLink>-->
        <!--              {{ $t('sidebars.addSellDocument') }}-->
        <!--            </CHeaderNavLink>-->
        <!--          </template>-->


        <!--          <CDropdownItem >-->
        <!--            {{$t('sidebars.cash')}}-->
        <!--          </CDropdownItem>-->

        <!--          <CDropdownItem >-->
        <!--            {{$t('sidebars.credit')}}-->
        <!--          </CDropdownItem>-->
        <!--        </CDropdown>-->
        <CHeaderNavItem class=" border-left" v-if="has_permission('SaleInvoice')">
          <CHeaderNavLink @click.native="open_sell_factor" target="_blank">
            {{ $t('sidebars.addSellDocument') }}
          </CHeaderNavLink>

        </CHeaderNavItem>
        <!--//******************************************-->
        <CHeaderNavItem class=" border-left" v-if="has_permission('AccountingReceive')">
          <CHeaderNavLink to="/dashboard/accounting/receive-operation" target="_blank" exact>
            {{ $t('sidebars.receiveOperation') }}
          </CHeaderNavLink>
        </CHeaderNavItem>
        <!--//******************************************-->      <!--//******************************************-->
        <CHeaderNavItem class=" border-left" v-if="has_permission('AccountingPay')">
          <CHeaderNavLink to="/dashboard/accounting/pay-operation" target="_blank" exact>
            {{ $t('sidebars.payOperation') }}
          </CHeaderNavLink>
        </CHeaderNavItem>
        <!--//******************************************-->
        <CHeaderNavItem v-if="get_access('journal') && has_permission('AddAccountingDoc')" class=" border-left">
          <CHeaderNavLink to="/dashboard/accounting/add-accounting-doc" target="_blank" exact>
            {{ $t('sidebars.journal') }}
          </CHeaderNavLink>
        </CHeaderNavItem>
        <!--//******************************************-->
        <CDropdown
            v-if="get_access('header_view') && has_permission('AccountingGroupSetting')"
            class="c-header-nav-items  border-left"
            :placement="drop_down_placement"
            add-menu-classes=""
        >
          <template #toggler>
            <CHeaderNavLink class="p-1">
              {{ $t('sidebars.view') }}
            </CHeaderNavLink>
          </template>


          <CDropdownItem @click="get_template_view_pdf(1)">{{ $t("Customers") }}</CDropdownItem>
          <CDropdownDivider></CDropdownDivider>

          <CDropdownItem @click="get_template_view_pdf(2)">{{ $t("Suppliers") }}</CDropdownItem>
          <CDropdownDivider></CDropdownDivider>

          <CDropdownItem @click="get_template_view_pdf(3)">{{ $t("Personals") }}</CDropdownItem>
          <CDropdownDivider>
          </CDropdownDivider>

          <CDropdownItem @click="get_template_view_pdf(4)">{{ $t('persons') }}</CDropdownItem>
          <CDropdownDivider>
          </CDropdownDivider>

          <CDropdownItem @click="get_template_view_pdf(6)">{{ $t("items") }}</CDropdownItem>

        </CDropdown>

        <!--//******************************************-->

        <CDropdown
            v-if="get_access('header_view')"
            v-show="false"
            class="c-header-nav-items  border-left"
            :placement="drop_down_placement"
            add-menu-classes=""
        >
          <template #toggler>
            <CHeaderNavLink class="p-1">
              {{ $t('sidebars.view') }}
            </CHeaderNavLink>
          </template>


          <CDropdownItem class="p-1" @click="open_orders()">
            {{ $t('sidebars.quotes') }}
          </CDropdownItem>

          <CDropdownItem class="p-1">
            {{ $t('sidebars.invoices') }}
          </CDropdownItem>
          <CDropdownItem v-if="get_access('delivery')" class="p-1" to="/dashboard/delivery/order-list">
            {{ $t('sidebars.delivery') }}
          </CDropdownItem>
          <CDropdownItem class="p-1" to="/dashboard/orders/add-order">
            {{ $t('sidebars.purchase') }}
          </CDropdownItem>
          <CDropdownItem class="p-1" to="/dashboard/products/list">
            {{ $t('sidebars.item') }}
          </CDropdownItem>
          <CDropdownItem class="p-1" to="/dashboard/sale-orders/list-customer">
            {{ $t('sidebars.customers') }}
          </CDropdownItem>
          <CDropdownItem class="p-1" to="/dashboard/orders/report">
            {{ $t('sidebars.suppliers') }}
          </CDropdownItem>
          <CDropdownItem class="p-1">
            {{ $t('payingList') }}
          </CDropdownItem>
        </CDropdown>
        <!--//******************************************-->
        <!--//******************************************-->
        <CHeaderNavItem class=" border-left" v-if="has_permission('BuyOrder')">

          <CHeaderNavLink to="/dashboard/orders/purchase-doc/1" target="_blank">
            {{ $t('sidebars.addBuyDocument') }}
          </CHeaderNavLink>
        </CHeaderNavItem>
        <!--//******************************************-->
        <CHeaderNavItem class=" border-left" v-if="has_permission('WarehouseOperation')">

          <CHeaderNavLink to="/dashboard/products/inventory-return-operation" target="_blank">
            {{ $t('returnOperation') }}
          </CHeaderNavLink>
        </CHeaderNavItem>
        <!--//******************************************-->


        <CHeaderNavItem v-if="get_access('delivery') && has_permission('Delivery')" class=" border-left">
          <CHeaderNavLink to="/dashboard/visitors/drivers" target="_blank" exact>
            {{ $t('sidebars.delivery') }}
          </CHeaderNavLink>
        </CHeaderNavItem>
        <!--//******************************************-->

        <CHeaderNavItem v-if="get_access('cartable')  && has_permission('BuyOrder')" class=" border-left">
          <CHeaderNavLink to="/dashboard/orders/cartable" exact>
            {{ $t('OfficeRequest') }}
            <!--            <CBadge  class="mr-2" color="success">{{reminders.length}}</CBadge>-->

          </CHeaderNavLink>

        </CHeaderNavItem>
        <!--//******************************************-->
        <CHeaderNavItem v-if="get_access('reminder')" class=" border-left">
          <CHeaderNavLink to="/dashboard/base/reminder" target="_blank" exact>
            {{ $t('sidebars.reminder') }}
            <CBadge class="mr-3" color="success">{{ reminders.length }}</CBadge>

          </CHeaderNavLink>
        </CHeaderNavItem>
        <!--//******************************************-->
        <!--        <CHeaderNavItem class=" border-left">-->
        <!--          <CHeaderNavLink to="/dashboard/base/reminder" exact>-->
        <!--            ریمایندر-->
        <!--            <CBadge color="success" class="mr-3">{{reminders.length}}</CBadge>-->

        <!--          </CHeaderNavLink>-->
        <!--        </CHeaderNavItem>-->
        <!--//******************************************-->
        <CDropdown
            inNav
            class="c-header-nav-items"
            placement="bottom-end"
            add-menu-classes="pt-0"
        >
          <template #toggler>
            <CHeaderNavLink>
              <CBadge class="mr-3" color="success">{{ cheques_list.length }}</CBadge>
              <CIcon name="cil-bell"/>

            </CHeaderNavLink>
          </template>

          <CDropdownItem>
            {{ $t('components.chequeList') }}
          </CDropdownItem>
          <CDropdownItem v-for="cheque in cheques_list" v-bind:key="cheque.id">
            <!--            <CIcon name="cil-check"/>-->
            <div v-if="cheque.type==1">
             <CRow>
               <CCol col="12">
                 {{$t('payChequeDoc')}}
               </CCol>
               <CCol col="12">
                 {{(cheque.partyName)}}
               </CCol>
               <CCol col="12">
                 {{get_currency(cheque.price)}}
               </CCol>
               <CCol col="12">
                 {{(cheque.bankName)}}
               </CCol>
               <CCol col="6">
                 {{get_date(cheque.sarRecidDate)}}
               </CCol>
               <CCol col="6">
                 {{(cheque.serial)}}
               </CCol>
             </CRow>

            </div>
            <div v-else>
              <CRow>
                <CCol col="12">
                  {{$t('receiveChequeDoc')}}
                </CCol>
                <CCol col="12">
                  {{(cheque.partyName)}}
                </CCol>
                <CCol col="12">
                  {{get_currency(cheque.price)}}
                </CCol>
                <CCol col="12">
                  {{(cheque.bankName)}}
                </CCol>
                <CCol col="6">
                  {{get_date(cheque.sarRecidDate)}}
                </CCol>
                <CCol col="6">
                  {{(cheque.serial)}}
                </CCol>
              </CRow>

            </div>
          </CDropdownItem>

        </CDropdown>

        <!--//******************************************-->


        <!--//******************************************-->

      </CHeaderNav>

      <CHeaderNav class="mr-4  mr-auto">
        <!--        ******************************************8-->
        <CHeaderNavItem class="d-md-down-none mx-2" v-if="multiple_language == 'true'">

          <CSelect
              :value.sync="selected_language"
              :options="[{label:'English',value:'en'},{label:'فارسی',value:'fa'}]"
          />

        </CHeaderNavItem>
        <!--********************************************************-->
        <CHeaderNavItem class="d-md-down-none mx-2" v-if="false">
          <CHeaderNavLink>
            <CIcon name="cil-bell"/>
          </CHeaderNavLink>
        </CHeaderNavItem>

        <!--*********************************************************-->
        <!--*********************************************************-->
        <CHeaderNavItem class="d-md-down-none mx-2" v-if="false">
          <CHeaderNavLink>
            <CIcon name="cil-list"/>
          </CHeaderNavLink>
        </CHeaderNavItem>
        <!--*************************************************************-->
        <CHeaderNavItem class="d-md-down-none mx-2" v-if="false">
          <CButton v-on:click="darkThemeSwitch">
            <CIcon v-if="this.$store.state.theme_mode=='dark'" class="text-light" name="cil-sun"/>
            <CIcon v-if="this.$store.state.theme_mode=='light'" name="cil-moon"/>

          </CButton>
        </CHeaderNavItem>
        <!--        ******************************************8-->

        <CHeaderNavItem class="d-md-down-none mx-2" v-if="false">
          <CHeaderNavLink>
            <CIcon name="cil-envelope-open"/>
          </CHeaderNavLink>
        </CHeaderNavItem>

        <!--        ******************************************8-->
        <!--        ******************************************8-->

        <!--              <TheHeaderDropdownAccnt/>-->
        <CHeaderNavItem class="d-md-down-none mx-2" v-if="false">
          <CButton @click="$store.commit('toggleAnotherSidebar')">
            <CIcon v-if="this.$store.state.theme_mode=='light'" name="cil-applications"/>
            <CIcon v-if="this.$store.state.theme_mode=='dark'" class="text-light" name="cil-applications"/>
          </CButton>
        </CHeaderNavItem>

      </CHeaderNav>
      <CSubheader class="px-1" v-if="false">
        <CCol cols="6">
          <CBreadcrumbRouter class="border-0 mb-0"/>
        </CCol>
        <CCol cols="6" ref="header_action">

        </CCol>
      </CSubheader>

    </CHeader>
    <div>
      <CCard v-if="header_validate_errors.length">
        <CCardHeader>
          <strong>{{ $t('dialogs.fixErrors') }}</strong>

        </CCardHeader>
        <CCardBody>
          <div>

            <CAlert v-for="error in header_validate_errors" show color="danger">{{ error }}</CAlert>

          </div>
        </CCardBody>
      </CCard>
      <CModal
          :show.sync="export_modal"
          :no-close-on-backdrop="false"
          color="transparent"
          border-color="primary"
          :title="$t('ExportData')"
      >
        <download-excel :data="json_data"
                        :name="export_file_name"
                        @click.native="export_modal=false"
        >
          <CButton color="secondary">
            {{ $t('DownloadExcel') }}

          </CButton>
        </download-excel>


        <template #footer>

          <CButton
              @click="export_modal = false"
              color="success"
          >{{ $t("buttons.cancel") }}
          </CButton>
        </template>
      </CModal>

    </div>
  </div>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import themeChanger from "../theme";
import axios from "axios";
import Vue from "vue";
import JsonExcel from "vue-excel-ultra";

Vue.component("downloadExcel", JsonExcel);

export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt
  },
  data() {
    return {
      selected_language: '',
      mounted_status: 0,
      themeChanger: null,
      reminders: [],
      cheques_list: [],
      multiple_language: localStorage.getItem('multiple_language'),
      header_validate_errors: [],
      drop_down_placement: 'bottom-start',
      export_file_name: '',
      export_modal: false,
      json_data: [],
    }
  },
  created() {
    this.themeChanger = new themeChanger();
  },
  mounted() {
    setInterval(this.get_reminder(), 1000 * 5 * 60);

    this.selected_language = localStorage.getItem("language");
    console.log("selected language is ", this.selected_language)
    if (this.selected_language == 'فارسی') {
      this.selected_language = 'fa';
    }
    if (this.selected_language == 'en') {
      this.selected_language = 'en'
      this.$i18n.locale = "en"
      localStorage.setItem("language", 'en');

    }

    if (this.selected_language == "fa") {
      this.$i18n.locale = "fa"
      this.selected_language = "fa"
      localStorage.setItem("language", "fa");
      this.drop_down_placement = 'bottom-end';

    }
    console.log(this.selected_language)

    // this.$root.modal_component = this.$refs.modal2;
    this.$root.root_validate_errors = [];
    this.$root.header_action = this.$refs['header_action'];
    this.$root.base_url = localStorage.getItem('api_address');
    this.$root.company_name = localStorage.getItem('app_name');
    this.header_validate_errors = this.$root.root_validate_errors;

    this.get_pay_cheques_list()
  }, watch: {
    '$root.root_validate_errors': function () {
      // this.header_validate_errors = this.$root.root_validate_errors;
      if (this.$root.root_validate_errors.length > 0) {
        this.$root.modal_component.show_validate_errors(this.$root.root_validate_errors);
        // setTimeout(() =>
        //         this.$refs.errors_container.scrollIntoView()
        //     , 500);

      }
    },
    'selected_language': function () {
      console.log("header selected langiage is ", this.selected_language, this.mounted_status)
      if (this.mounted_status == 1) {
        localStorage.setItem('language', this.selected_language);
        this.$i18n.locale = this.selected_language;

        // console.log("language changed " + localStorage.getItem("language"));
        location.reload();

      } else {
        this.mounted_status = 1;

      }
    },
  }, methods: {
    open_orders() {
      localStorage.setItem("sale_factors_active_tab", 1)
      window.open("/dashboard/sale-orders/sale-invoice")
      // this.$router.push({path:'/dashboard/sale-orders/sale-invoice'})
    },
    open_sell_factor() {
      localStorage.setItem("sale_factors_active_tab", 0)
      window.open("/dashboard/sale-orders/sale-invoice")
      // this.$router.push({path:'/dashboard/sale-orders/sale-invoice'})
    },
    get_reminder() {
      var self = this;

      const formData = new FormData();

      formData.append('FirstDate', this.get_today());


      axios.post('GetUserReminderAlarm', formData, {}).then(function (response) {
        console.log("Reminder", response.data)
        self.reminders = response.data.data

      }).catch(function (error) {
        console.log(error);
      });

    },
    get_pay_cheques_list() {
      var self = this;

      const formData = new FormData();

      formData.append('FromDate', this.get_today());
      formData.append('ToDate', this.get_day_after_today_in_day(3));


      axios.post('GetFactorPayChequeByDate', formData, {}).then(function (response) {
        response.data.data.forEach(function (val){
          val.type = 1
        })
        self.cheques_list = response.data.data
        self.get_receive_cheques_list()
      }).catch(function (error) {
        console.log(error);
      });

    },
    get_receive_cheques_list() {
      var self = this;

      const formData = new FormData();

      formData.append('FromDate', this.get_today());
      formData.append('ToDate', this.get_day_after_today_in_day(3));

      axios.post('GetReceiverChequeByDate', formData, {}).then(function (response) {
        response.data.data.forEach(function (val){
          val.type = 2
        })
        self.cheques_list.push(...response.data.data)

      }).catch(function (error) {
        console.log(error);
      });

    },

    darkThemeSwitch() {
      this.$store.commit('toggle_theme_mode')
      this.themeChanger._darkThemeSwitch();
    },
    get_customers() {
      var self = this;


      const formData = new FormData();

      var url = "GetFullPersons";
      formData.append('IsVendor', false);
      formData.append('IsWorker', false);
      formData.append('IsCustomer', true);
      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.export_file_name = "customers.xls"
          self.export_modal = true;
          var received_data = [];
          self.json_data = [];
          received_data = response.data.data.filter(item => item.isCustomer);
          // received_data = received_data.map((item, row) => {
          //   return {...item, row}
          // });
          // received_data.forEach((val) => {
          //   var obj = {id: val.row+1, Mobile: val.mobileNo,
          //   Name:val.userName}
          //   self.json_data.push(val);
          // });
          var pros = [];
          received_data.forEach(function (val) {
            pros.push({
              "Customer Code": val.personCode,
              "Title": val.title,
              "Name": val.userName,
              "Middle Name": val.catTitle,
              "Surname": val.surName,
              "Type": val.brandName,
              "Group Name": val.groupName,
              "Job Profile": val.jobProfile,
              "Vat No": val.exitTypeTitle,
              "Company Reg No": val.saleVAT,
              "Bill Address": val.purchasePrice,
              "Delivery Address": val.customerPrice,
              "County": val.wholesalePrice,
              "City": val.shopPrice,
              "Town": val.wholesaleDiscount,
              "District": val.partnerDiscount,
              "Postcode": val.partnerDiscount,
              "Country": val.partnerDiscount,
              "Shop No": val.partnerDiscount,
              "Mobile No": val.mobileNo,
              "Email": val.email,
              "Website": val.partnerDiscount,

            })
          })
          //     "purchaceVAT":val.purchaceVAT,
          //     "summary":val.summary,
          //     "partnerPrice":val.partnerPrice,

          self.json_data = pros
          self.export_modal = true;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_vendors() {
      var self = this;


      const formData = new FormData();


      var url = "GetFullPersons";
      formData.append('IsVendor', true);
      formData.append('IsWorker', false);
      formData.append('IsCustomer', false);
      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.export_file_name = "Suppliers.xls"

          self.export_modal = true;
          var received_data = [];
          self.json_data = [];
          received_data = response.data.data.filter(item => item.isVendor);
          // received_data = received_data.map((item, row) => {
          //   return {...item, row}
          // });
          // received_data.forEach((val) => {
          //   var obj = {id: val.row+1, Mobile: val.mobileNo,
          //   Name:val.userName}
          //   self.json_data.push(val);
          // });
          var pros = [];
          received_data.forEach(function (val) {
            pros.push({
              "Supplier Code": val.personCode,
              "Title": val.title,
              "Name": val.userName,
              "Surname": val.surName,
              "Type": val.brandName,
              "Category": val.brandName,
              "Vat No": val.exitTypeTitle,
              "Company Reg No": val.saleVAT,
              "Bill Address": val.purchasePrice,
              "Delivery Address": val.customerPrice,
              "County": val.wholesalePrice,
              "City": val.shopPrice,
              "Town": val.wholesaleDiscount,
              "District": val.partnerDiscount,
              "Postcode": val.partnerDiscount,
              "Country": val.partnerDiscount,
              "Office No": val.partnerDiscount,
              "Mobile No": val.mobileNo,
              "Email": val.email,
              "Website": val.partnerDiscount,

            })
          })
          self.json_data = pros
          self.export_modal = true;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_users(type) {
      var self = this;


      const formData = new FormData();

      var url = "GetFullPersons";
      if (type == 1) {//personals
        formData.append('IsVendor', false);
        formData.append('IsWorker', true);
        formData.append('IsCustomer', false);

      }
      if (type == 2) {//persons
        formData.append('IsVendor', false);
        formData.append('IsWorker', false);
        formData.append('IsCustomer', false);

      }
      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.export_modal = true;
          var received_data = [];
          self.json_data = [];
          received_data = response.data.data.filter(item => item.isWorker);
          // received_data = received_data.map((item, row) => {
          //   return {...item, row}
          // });
          // received_data.forEach((val) => {
          //   var obj = {id: val.row+1, Mobile: val.mobileNo,
          //   Name:val.userName}
          // self.json_data.push(val);
          // });

          var pros = [];
          if (type == 1) {//personals
            self.export_file_name = "Personals.xls"


            received_data.forEach(function (val) {
              pros.push({
                "Personnel Code": val.productCode,
                "Title": val.productName,
                "Name": val.productUnitName,
                "Middle Name": val.catTitle,
                "Surname": val.maintenanceTitle,
                "D.O.B": val.brandName,
                "Branch": val.exitTypeTitle,
                "Department": val.saleVAT,
                "Job Title": val.purchasePrice,
                "NINO": val.customerPrice,
                "Home No": val.wholesalePrice,
                "Mobile No": val.wholesalePrice,
                "Address": val.shopPrice,
                "Email": val.wholesaleDiscount,
                "Employment Date": val.partnerDiscount,
                "Leavers Date": val.partnerDiscount,

              })
            })
          }
          if (type == 2) {//persons
            self.export_file_name = "Persons.xls"

            received_data.forEach(function (val) {
              pros.push({
                "Person Code": val.productCode,
                "Title": val.productName,
                "Name": val.productUnitName,
                "Middle Name": val.catTitle,
                "Surname": val.maintenanceTitle,
                "Type": val.brandName,
                "Organization": val.exitTypeTitle,
                "Department": val.saleVAT,
                "Job Title": val.purchasePrice,
                "Office No": val.customerPrice,
                "Mobile No": val.wholesalePrice,
                "Address": val.shopPrice,
                "Email": val.wholesaleDiscount,
                "Website": val.partnerDiscount,

              })
            })
          }

          //     "purchaceVAT":val.purchaceVAT,
          //     "summary":val.summary,
          //     "partnerPrice":val.partnerPrice,

          self.json_data = pros
          self.export_modal = true;


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_lists_groups() {
      var self = this;

      const formData = new FormData();
      var url = "Get_AllAccountingGroups";
      // formData.append("MasterId", 0);
      // formData.append("FirstDate", self.start_date);
      // formData.append("SecondDate", self.end_date);
      self.data_accounting = [];
      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {
              self.export_file_name = "Charts.xls"


              response.data.data.forEach((val) => {
                if (val.accNature == 1) {
                  val.nature = self.$t('debtor');
                }
                if (val.accNature == 2) {
                  val.nature = self.$t('creditor');
                }
                if (val.accNature == 3) {
                  val.nature = self.$t('neutral');
                }
                if (val.accNature == 0) {
                  val.nature = '';
                }

                if (val.accType == 1) {
                  val.type = self.$t('permanent');
                }
                if (val.accType == 2) {
                  val.type = self.$t('temporary');
                }
                if (val.accType == 0) {
                  val.type = '';
                }
              });
              self.json_data = response.data.data.map((item, row) => {
                return {...item, row}
              });
              self.export_modal = true;


            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      )
          .catch(function (error) {
            console.log(error);
          });

    },

    get_products() {
      var self = this;

      const formData = new FormData();
      var url = "GetProductsFullInfo";
      // formData.append("MasterId", 0);
      // formData.append("FirstDate", self.start_date);
      // formData.append("SecondDate", self.end_date);
      self.data_accounting = [];
      // formData.append("id", 1);

      axios.get(url, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {
              self.export_file_name = "Items.xls"
              var pros = [];
              response.data.data.forEach(function (val) {
                if (val.barCode == null) {
                  val.barCode = "";
                }
                pros.push({
                  "Item Code": val.productCode,
                  "Item Name": val.productName,
                  "Package / V": val.productUnitName,
                  "Category": val.catTitle,
                  "Type": val.maintenanceTitle,
                  "Brand": val.brandName,
                  "INV Validation": val.exitTypeTitle,
                  "Sale VAT": val.saleVAT,
                  "Purchase Price": val.purchasePrice,
                  "Consumer Price": val.customerPrice,
                  "Delivery Price": val.wholesalePrice,
                  "Collection Price": val.shopPrice,
                  "Delivery Discount": val.wholesaleDiscount,
                  "Collection Discount": val.partnerDiscount,
                  "Order Point": val.orderPoint,
                  "Min Qty": val.existanceQty,
                  "Shelf Life": val.shelfLife,
                  "Stock Qty": val.existanceQty,
                  "Item": val.masterTitle,
                  "Item Id": val.id,
                  "BarCode": val.barCode,
                  "Inventory Code": val.inventoryCode,
                  "Package ID": val.productUnitId,
                  "ID": val.productId,
                  "Main Group": val.productNatureTitle,
                  "Main Group ID": val.productNatureId,
                  "Brand ID": val.brandId,
                  "Category ID": val.catRelId,
                  "INV Valuation ID": val.exitTypeId,
                  "Type ID": val.maintenanceId,
                  "Status ID": val.productStatusId,
                  "Status": val.productStatusTitle,
                  "Base Unit ID": val.unitId,
                  "Base Unit": val.unitName,
                  "Commission": val.commission,
                  "Weight": val.weight,
                  "Length": val.length,
                  "Width": val.width,
                  "Height": val.height,
                  "Specification ID": val.specificationId,
                  "Specification": val.specificationTitle,

                })
              })
              //     "purchaceVAT":val.purchaceVAT,
              //     "summary":val.summary,
              //     "partnerPrice":val.partnerPrice,

              self.json_data = pros
              self.export_modal = true;


            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      )
          .catch(function (error) {
            console.log(error);
          });

    },
    get_template_view_pdf(type) {
      var self = this;
      const formData = new FormData();
      var url = "DataViewExport";
      formData.append("Id", type);
      axios.post(url, formData, {responseType: 'blob'}).then(function (response) {

        // var content_data = response.data;
        const href = URL.createObjectURL(response.data);
        console.log(response)
        // create "a" HTML element with href to file & click
        const link = document.createElement('a');
        link.href = href;
        var file_name = response.filename
        if (type == 1) {
          file_name = "Customers.xlsx"
        }
        if (type == 2) {
          file_name = "Suppliers.xlsx"
        }
        if (type == 3) {
          file_name = "Personnel.xlsx"
        }
        if (type == 4) {
          file_name = "Persons.xlsx"
        }

        if (type == 5) {
          file_name = "ChartOfAccount.xlsx"
        }
        if (type == 6) {
          file_name = "Items.xlsx"
        }

        link.setAttribute('download', file_name); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
        // items = content_cats.orders;
        // if (content_data.statusCode == 0) {
        //   self.export_file_name="Users.xls"
        //
        //   self.export_modal = true;
        //   self.json_data = [];
        //
        //     self.json_data = response.data.data
        //     self.export_modal = true;
        //     setTimeout(function () {
        //       document.getElementById("download_json_template").click()
        //
        //     },300)
        //
        // } else {
        //   self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
        //
        // }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

  }
}
</script>
